import styled from 'styled-components';

const WhatWeDoStyle = styled.div`
	.title {
		margin-bottom: var(--titleToText);

		span {
			opacity: 0;
		}
	}

	.descriptionWrap {
		opacity: 0;

		.description {
			margin-bottom: var(--titleToContent);
		}
	}

	.whatWeDoWrap {
		.whatWeDoItem {
			opacity: 0;
			display: flex;
			align-items: center;
			border-bottom: 2px solid var(--color2);
			padding: var(--sp2-5x) 0;

			.iconCont {
				width: var(--sp6x);
				height: var(--sp6x);
				margin-right: var(--sp2x);
			}

			.description {
				flex: 1 1 auto;
			}

			&:first-child {
				border-top: 2px solid var(--color2);
			}
		}
	}

	@media only screen and (min-width: ${(props) => props.theme.mediaQuery.TabletSizeS}) {
		.descriptionWrap {
			display: flex;
			justify-content: flex-end;
			flex-wrap: wrap;

			.description {
				flex: 0 0 52%;
			}
		}

		.whatWeDoWrap {
			.whatWeDoItem {
				padding: var(--sp3x) 0;

				.iconCont {
					width: var(--sp7x);
					height: var(--sp7x);
					margin-right: var(--sp7x);
					display: flex;
					align-items: center;
					justify-content: center;
				}
			}
		}
	}

	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.DesktopSizeXSMin}) and (min-width: ${(props) => props.theme.mediaQuery.TabletSize}) {
		.whatWeDoWrap {
			.whatWeDoItem {
				max-width: 86.5%;
				padding: var(--sp4x) 0;
			}
		}
	}

	@media only screen and (min-width: ${(props) => props.theme.mediaQuery.TabletSize}) {
		.descriptionWrap {
			.description {
				flex: 0 0 48%;
			}
		}
	}

	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.DesktopSizeSMin}) and (min-width: ${(props) => props.theme.mediaQuery.DesktopSizeXS}) {
		.whatWeDoWrap {
			.whatWeDoItem {
				max-width: 90%;
				padding: var(--sp4x) 0;

				.iconCont {
					width: var(--sp7x);
					height: var(--sp7x);
					margin-right: var(--sp6x);
				}
			}
		}
	}

	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.DesktopSizeMMin}) and (min-width: ${(props) => props.theme.mediaQuery.DesktopSizeS}) {
		.whatWeDoWrap {
			.whatWeDoItem {
				max-width: 87%;
				padding: var(--sp4x) 0;

				.iconCont {
					width: var(--sp7x);
					height: var(--sp7x);
					margin-right: var(--sp6x);
				}
			}
		}
	}

	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.DesktopSizeLMin}) and (min-width: ${(props) => props.theme.mediaQuery.DesktopSizeM}) {
		.whatWeDoWrap {
			.whatWeDoItem {
				max-width: 90%;
				padding: var(--sp5x) 0;

				.iconCont {
					width: var(--sp7x);
					height: var(--sp7x);
					margin-right: var(--sp8x);
				}
			}
		}
	}

	@media only screen and (min-width: ${(props) => props.theme.mediaQuery.DesktopSizeL}) {
		.descriptionWrap {
			.description {
				flex: 0 0 49%;
			}
		}

		.whatWeDoWrap {
			.whatWeDoItem {
				max-width: 90%;
				padding: var(--sp5x) 0;

				.iconCont {
					width: var(--sp8x);
					height: var(--sp8x);
					margin-right: var(--sp10x);
				}
			}
		}
	}

	@media only screen and (min-width: ${(props) => props.theme.mediaQuery.DesktopSizeXL}) {
		.whatWeDoWrap {
			.whatWeDoItem {
				max-width: 87%;
				padding: var(--sp6x) 0;

				.iconCont {
					width: var(--sp9x);
					height: var(--sp9x);
					margin-right: var(--sp12x);
				}
			}
		}
	}
`;

export default WhatWeDoStyle;
